var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import OptionVolatilityLabPanelTemplate from '@front/templates/OptionVolatilityLabPanelTemplate.html';
import { PanelNames } from '../../UtilsClasses/FactoryConstants';
import { DynProperty } from '@shared/commons/DynProperty';
import { ApplicationPanelWithTable } from '../ApplicationPanelWithTable';
import { Resources } from '@shared/localizations/Resources';
import { getVolatilityLabSideKey, VolatilityLabSide } from '@shared/commons/cache/OptionMaster/OptionTrader/OptionVolatilityLab/VolatilityLabSide';
import { getVolatilityLabBasisKey, VolatilityLabBasis } from '@shared/commons/cache/OptionMaster/OptionTrader/OptionVolatilityLab/VolatilityLabBasis';
import { OptionVolatilityLabSeriesTableItem } from '../../cache/OptionMaster/OptionVolatilityLabSeriesTableItem';
import { AnalyzerVolatilityLine } from '@shared/commons/cache/OptionMaster/OptionTrader/OptionAnalyzer/AnalyzerVolatilityLine';
import { SessionSettings } from '@shared/commons/SessionSettings';
import { ThemeManager } from '../../misc/ThemeManager';
import { DataCache } from '@shared/commons/DataCache';
import { HistoryType } from '@shared/utils/History/HistoryType';
import { createContextMenuItemsFromEnum } from '@shared/utils/ContextMenuUtils';
import { LayersEnum } from '@front/chart/Utils/LayersEnum';
export class OptionVolatilityLabPanel extends ApplicationPanelWithTable {
    get selectedSide() {
        const selectedSideItem = this.get('selectedSideItem');
        if (isNullOrUndefined(selectedSideItem)) {
            return undefined;
        }
        else {
            return selectedSideItem.value;
        }
    }
    set selectedSide(value) {
        const sideItems = this.get('sideItems');
        for (let i = 0; i < sideItems.length; i++) {
            if (sideItems[i].value === value) {
                void this.set('selectedSideItem', sideItems[i]);
            }
        }
    }
    constructor() {
        super();
        this._quotesMap = new Map();
        this._isRepopulateChart = false;
        this._isUpdateChart = false;
        this._isResetChartScales = false;
        this._seriesLineColors = [];
        this._subscribedSeriesDates = [];
        this.Name = 'OptionVolatilityLablPanel';
        this.headerLocaleKey = 'panel.optionVolatilityLab';
        this.NeedCalculateRowCount = false;
        this.repopulate = this.repopulate.bind(this);
        this.onQuoteChanged = this.onQuoteChanged.bind(this);
    }
    // #region Overrides
    oncomplete() {
        super.oncomplete();
        this.on('expandCollapsSettings_btnClick', this.onExpandCollapseButtonClicked);
        this.observe('visible', this.onVisibleChanged, { init: false });
        this.observe('selectedSideItem', this.onSelectedSideItemChanged, { init: false });
    }
    onteardown() {
        this.off('expandCollapsSettings_btnClick', this.onExpandCollapseButtonClicked);
        this.unsubscribeAllOptions();
        if (!isNullOrUndefined(this._seriesTable)) {
            this._seriesTable.AfterEditItem.UnSubscribe(this.seriesTable_onAfterEditItem, this);
            this._seriesTable.OnSelectionChanged.UnSubscribe(this.seriesTable_onSelectionChanged, this);
        }
        this._optionTrader.unsubscribeOnRepopulate(this.repopulate);
        this._optionTrader.unsubscribeOnQuoteChanged(this.onQuoteChanged);
        super.onteardown();
    }
    getType() {
        return PanelNames.OptionVolatilityLabPanel;
    }
    jbInit() {
        this._seriesTable = super.findAllComponents('quickTableRactive')[0].quickTable;
        this._chartRactive = super.findAllComponents('optionVolatilityLabChartRactive')[0];
        super.jbInit();
        this._seriesTable.showHeader = false;
        this._seriesTable.InitializeDirect(new OptionVolatilityLabSeriesTableItem(null, null, null));
        this._seriesTable.UpdateSortedColumns();
        this._seriesTable.AfterEditItem.Subscribe(this.seriesTable_onAfterEditItem, this);
        this._seriesTable.OnSelectionChanged.Subscribe(this.seriesTable_onSelectionChanged, this);
    }
    localize() {
        super.localize();
        void this.set({
            settingsLabel: Resources.getResource('general.Settings'),
            sideLabel: Resources.getResource('property.Side'),
            visibleSeriesTableLabel: Resources.getResource('property.VisibleSeries')
        });
        this._seriesTable.localize();
        this._chartRactive.terceraChart.Localize();
    }
    callThemeChange() {
        this.themeChange();
    }
    callCallback(properties) {
        this.callBack(properties);
    }
    themeChange() {
        super.themeChange();
        this.themeChangeLineColors();
        const seriesTableRactive = this.findComponent('quickTableRactive');
        seriesTableRactive.themeChange();
        this._chartRactive.themeChange();
    }
    themeChangeLineColors() {
        this._seriesLineColors = [
            ThemeManager.colors.OptionMasterVolatilityLabLineColor1,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor2,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor3,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor4,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor5,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor6,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor7,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor8,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor9,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor10,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor11,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor12,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor13,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor14,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor15,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor16,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor17,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor18,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor19,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor20,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor21,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor22,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor23,
            ThemeManager.colors.OptionMasterVolatilityLabLineColor24
        ];
        for (let i = 0; i < this._seriesTable.rowsArray.length; i++) {
            const row = this._seriesTable.rowsArray[i];
            const item = row.item;
            if (!isNullOrUndefined(item) && !isNullOrUndefined(item.seriesLine)) {
                item.seriesLine.color = this._seriesLineColors[i % this._seriesLineColors.length];
            }
        }
    }
    Properties() {
        const optionVolatilityLab = this._optionTrader.optionVolatilityLab;
        const properties = super.Properties();
        let sortIndex = 0;
        const dp = new DynProperty('property.Basis', optionVolatilityLab.basis, DynProperty.COMBOBOX, DynProperty.VOLATILITY_LAB_GROUP);
        dp.sortIndex = sortIndex++;
        dp.COMBOBOX_TYPE = DynProperty.INTEGER;
        dp.objectVariants = createContextMenuItemsFromEnum(VolatilityLabBasis, getVolatilityLabBasisKey);
        properties.push(dp);
        return properties;
    }
    callBack(newProperties) {
        super.callBack(newProperties);
        const optionVolatilityLab = this._optionTrader.optionVolatilityLab;
        const dp = DynProperty.getPropertyByGroupAndName(newProperties, DynProperty.VOLATILITY_LAB_GROUP, 'property.Basis');
        if (!isNullOrUndefined(dp === null || dp === void 0 ? void 0 : dp.value)) {
            optionVolatilityLab.basis = dp.value;
        }
        this._isRepopulateChart = true;
        this._isResetChartScales = true;
    }
    TickAsync() {
        super.TickAsync();
        const isVisible = this.get('visible');
        if (!isVisible) {
            return;
        }
        if (this._isRepopulateChart) {
            this._isRepopulateChart = false;
            this.repopulateChart();
        }
        if (this._isResetChartScales) {
            this._isResetChartScales = false;
            this._chartRactive.terceraChart.resetScales();
        }
        const chart = this._chartRactive.terceraChart;
        if (chart.needRedraw) {
            chart.needRedraw = false;
            chart.Draw();
            chart.AddForceUpdate();
        }
        this.updateTable(this._seriesTable);
    }
    layoutTable() {
        super.layoutTable();
        this.layoutTableResize(this._chartRactive);
        for (const table of this.findAllComponents('quickTableRactive')) {
            this.layoutTableResize(table);
        }
    }
    repopulate() {
        super.repopulate();
        const optionTrader = this._optionTrader;
        if (isNullOrUndefined(optionTrader.fakeOption) || isNullOrUndefined(optionTrader.underlier)) {
            return;
        }
        this.unsubscribeAllOptions();
        this._seriesTable.ClearAll();
        const seriesDates = this._optionTrader.seriesDates;
        const seriesRowHeight = this._seriesTable.rowHeight + 2;
        const minSeriesTableHeight = seriesRowHeight;
        const maxSeriesTableHeight = seriesRowHeight * 7;
        const seriesTableHeight = Math.min(maxSeriesTableHeight, Math.max(minSeriesTableHeight, seriesRowHeight * seriesDates.length));
        for (let i = 0; i < seriesDates.length; i++) {
            const seriesDate = seriesDates[i];
            const seriesLine = new AnalyzerVolatilityLine();
            seriesLine.isActive = false;
            seriesLine.color = this._seriesLineColors[i % this._seriesLineColors.length];
            const seriesTableItem = new OptionVolatilityLabSeriesTableItem(seriesDate, seriesLine, SessionSettings);
            this._seriesTable.AddItem(seriesTableItem);
        }
        void this.set('seriesTableHeight', `${seriesTableHeight}px`);
        const side = this._optionTrader.optionVolatilityLab.side;
        const selectedSide = this.selectedSide;
        if (selectedSide !== side) {
            this.selectedSide = side;
        }
        else {
            this._isRepopulateChart = true;
            this._isResetChartScales = true;
        }
    }
    updateChart() {
        if (this._isUpdateChart) {
            const chart = this._chartRactive.terceraChart;
            chart.update(this._optionTrader.getVolatilityLabChartData(this._subscribedSeriesDates));
            this._isUpdateChart = false;
        }
    }
    repopulateChart() {
        const chart = this._chartRactive.terceraChart;
        chart.set(this._optionTrader.getVolatilityLabChartData(this._subscribedSeriesDates));
        for (let i = 0; i < this._seriesTable.rowsArray.length; i++) {
            const item = this._seriesTable.rowsArray[i].item;
            if (!isNullOrUndefined(item)) {
                chart.setLineColor(item.expirationDate, item.seriesLine.color);
            }
        }
        this.updateChartLinesSelection();
    }
    updateChartLinesSelection() {
        const selectedRowsId = this._seriesTable.selectedRowIds;
        if (!isValidArray(selectedRowsId)) {
            return;
        }
        const selectedDates = [];
        for (let i = 0; i < selectedRowsId.length; i++) {
            const item = this._seriesTable.rows[selectedRowsId[i]].item;
            selectedDates.push(item.expirationDate);
        }
        this._chartRactive.terceraChart.setSelectedLines(selectedDates);
    }
    // #endregion
    // #region Eventhandlers
    onExpandCollapseButtonClicked() {
        return __awaiter(this, void 0, void 0, function* () {
            const isExpanded = this.get('isSettingsExpanded');
            yield this.set('isSettingsExpanded', !isExpanded);
            this.layoutTable();
        });
    }
    onVisibleChanged() {
        this.layoutTable();
    }
    onSelectedSideItemChanged(newValue, prevValue) {
        if (newValue === prevValue) {
            return;
        }
        const selectedSide = this.selectedSide;
        if (isNullOrUndefined(selectedSide)) {
            return;
        }
        this._optionTrader.optionVolatilityLab.side = selectedSide;
        this._isRepopulateChart = true;
        this._isResetChartScales = true;
    }
    seriesTable_onAfterEditItem(data) {
        const tableItem = data.row.item;
        const chart = this._chartRactive.terceraChart;
        switch (data.realColumnIndex) {
            case OptionVolatilityLabSeriesTableItem.ACTIVE_COL_INDEX:
                tableItem.seriesLine.isActive = !tableItem.seriesLine.isActive;
                this.subscribeUnsubscribeSeries(tableItem.expirationDate, tableItem.seriesLine.isActive);
                this._isRepopulateChart = true;
                this._isResetChartScales = true;
                break;
            case OptionVolatilityLabSeriesTableItem.COLOR_COL_INDEX:
                tableItem.seriesLine.color = data.newValue;
                chart.setLineColor(tableItem.expirationDate, tableItem.seriesLine.color);
                chart.IsDirty(LayersEnum.All);
                break;
        }
        data.row.FillRowByItem(tableItem, true);
    }
    seriesTable_onSelectionChanged() {
        this.updateChartLinesSelection();
    }
    onQuoteChanged() {
        this._isUpdateChart = true;
    }
    // #endregion
    setOptionTrader(optionTrader) {
        this._optionTrader = optionTrader;
        this._optionTrader.subscribeOnRepopulate(this.repopulate);
        this._optionTrader.subscribeOnQuoteChanged(this.onQuoteChanged);
    }
    applyCursor(cursor) {
        if (!isNullOrUndefined(this._chartRactive)) {
            void this._chartRactive.setCursor(cursor);
        }
    }
    updateTable(table) {
        table.updateRowsCellsValues();
        table.Draw();
        table.needRedraw = false;
        table.needRedrawBackground = true;
    }
    subscribeUnsubscribeSeries(expirationDate, isSubscribe) {
        if (isSubscribe) {
            this._subscribedSeriesDates.push(expirationDate);
            const options = this._optionTrader.getOptions(expirationDate);
            for (let i = 0; i < options.length; i++) {
                this.subscribeOption(options[i]);
            }
        }
        else {
            const options = this._optionTrader.getOptions(expirationDate);
            for (let i = 0; i < options.length; i++) {
                this.unsubscribeOption(options[i]);
            }
            const index = this._subscribedSeriesDates.indexOf(expirationDate);
            if (index !== -1) {
                this._subscribedSeriesDates.splice(index, 1);
            }
        }
    }
    subscribeOption(option) {
        if (option.callEnabled) {
            DataCache.FQuoteCache.addListener(option.call, this, HistoryType.QUOTE_LEVEL1);
            DataCache.FQuoteCache.addListener(option.call, this, HistoryType.QUOTE_TRADES);
            DataCache.FQuoteCache.addListener(option.call, this, HistoryType.QUOTE_INSTRUMENT_DAY_BAR);
        }
        if (option.putEnabled) {
            DataCache.FQuoteCache.addListener(option.put, this, HistoryType.QUOTE_LEVEL1);
            DataCache.FQuoteCache.addListener(option.put, this, HistoryType.QUOTE_TRADES);
            DataCache.FQuoteCache.addListener(option.put, this, HistoryType.QUOTE_INSTRUMENT_DAY_BAR);
        }
    }
    unsubscribeOption(option) {
        if (option.callEnabled && !isNullOrUndefined(option.call)) {
            this._quotesMap.delete(option.call.InstrumentTradableID);
            DataCache.FQuoteCache.removeListener(option.call, this, HistoryType.QUOTE_LEVEL1);
            DataCache.FQuoteCache.removeListener(option.call, this, HistoryType.QUOTE_TRADES);
            DataCache.FQuoteCache.removeListener(option.call, this, HistoryType.QUOTE_INSTRUMENT_DAY_BAR);
        }
        if (option.putEnabled && !isNullOrUndefined(option.put)) {
            this._quotesMap.delete(option.put.InstrumentTradableID);
            DataCache.FQuoteCache.removeListener(option.put, this, HistoryType.QUOTE_LEVEL1);
            DataCache.FQuoteCache.removeListener(option.put, this, HistoryType.QUOTE_TRADES);
            DataCache.FQuoteCache.removeListener(option.put, this, HistoryType.QUOTE_INSTRUMENT_DAY_BAR);
        }
    }
    unsubscribeAllOptions() {
        for (let i = 0; i < this._subscribedSeriesDates.length; i++) {
            const expirationDate = this._subscribedSeriesDates[i];
            const options = this._optionTrader.getOptions(expirationDate);
            for (let j = 0; j < options.length; j++) {
                this.unsubscribeOption(options[j]);
            }
        }
        this._subscribedSeriesDates = [];
        this._quotesMap.clear();
    }
    newQuote(quote) {
        if (quote.Type === HistoryType.QUOTE_INSTRUMENT_DAY_BAR) {
            this._isRepopulateChart = true;
            this._isResetChartScales = true;
            return;
        }
        const tradableId = quote.InstrumentTradableID;
        if (this._quotesMap.get(tradableId)) {
            this._isUpdateChart = true;
        }
        else {
            this._quotesMap.set(tradableId, true);
            this._isRepopulateChart = true;
            this._isResetChartScales = true;
        }
    }
}
ApplicationPanelWithTable.extendWith(OptionVolatilityLabPanel, {
    template: OptionVolatilityLabPanelTemplate,
    data: function () {
        return {
            settingsLabel: '',
            sideLabel: '',
            visibleSeriesTableLabel: '',
            isSettingsExpanded: true,
            seriesTableHeight: '25px',
            sideItems: createContextMenuItemsFromEnum(VolatilityLabSide, getVolatilityLabSideKey),
            selectedSideItem: undefined
        };
    },
    computed: {
        terceraChartPanelContext: {
            get: function () {
                return this;
            },
            set: function (value) { }
        }
    }
});
